import apiHeader from '@/helpers/apiHeader';

const cataloguerFormService = {
    clone(mcr_item_id) {
        return apiHeader.get(`request-pool/catalouging-form/clone/${mcr_item_id}`);
    },
    update(id, params) {
        return apiHeader.post(`request-pool/catalouging-form/update/${id}`, params);
    },
    updatePerItem(params) {
        return apiHeader.post("request-pool/catalouging-form/update-per-item", params);
    },
    // Simpan draft ANTAM dari form Cataloguer FORM02 -- status item tetap, PO text tidak di-generate.
    updatePerItemDraft(params) {
        return apiHeader.post("request-pool/catalouging-form/update-per-item-draft", params);
    },
    // Import item dari Excel ke form Cataloguer FORM02 (ANTAM draft) -- payload & validasi sama dengan Save Draft ANTAM.
    importItems(idEmcr, file) {
        const fd = new FormData();
        fd.append("file", file);
        return apiHeader.post(`request-pool/catalouging-form/import/${idEmcr}`, fd, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    saveDraft(id, params) {
        return apiHeader.post(`request-pool/catalouging-form/save-draft/${id}`, params);
    },
    saveNoteItem(mcr_item_id, params) {
        return apiHeader.post(`request-pool/catalouging-form/save-note-emcritem/${mcr_item_id}`, params);
    },
    saveNoteEmcr(mcrCode, params) {
        return apiHeader.post(`request-pool/catalouging-form/save-note-emcr/${mcrCode}`, params);
    },
    getDuplicationInItem(type, params) {
        return apiHeader.post(`request-pool/catalouging-form/check-duplicate/${type}`, params);
    },
    updateItemStatus(mcr_item_code, params) {
        return apiHeader.post(`request-pool/catalouging-form/save-status-emcritem/${mcr_item_code}`, params);
    },
    checkPrPo(params) {
        return apiHeader.post('request-pool/catalouging-form/check-pr-po', params);
    }
};

export default cataloguerFormService;